import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

/**
 * Export the current view to an xlsx by hitting a backend endpoint with the
 * same filters. Streams the blob and triggers a browser download.
 */
export default function ExportXlsxButton({ endpoint, filename, params = {}, testId, label = "Export xlsx" }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const qs = new URLSearchParams(params).toString();
      const url = `${endpoint}${qs ? `?${qs}` : ""}`;
      const { data } = await api.get(url, { responseType: "blob" });
      const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (e) {
      toast.error("Export failed", { description: formatApiError(e.response?.data?.detail) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={download}
      disabled={busy}
      className="cf-touch inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-surface text-ink text-sm font-medium hover:bg-surface-2 transition-colors border border-hairline disabled:opacity-50"
    >
      {busy ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />}
      {busy ? "Exporting…" : label}
    </button>
  );
}
